import {memo, useMemo} from 'react'
import {Checkbox, Empty, Flex, Table, Typography} from 'antd'
import {useIntl} from 'react-intl'
import {SELECT_DESELECT_CANDIDATE, useCandidateContext,} from '../context/context'
import RecordsCount from '../../../../common/RecordsCount'
import { emptyStateStyle } from '../useTableScrollY'
import EllipsisTooltip from '../../../../common/EllipsisTooltip'

const CandidateRow = memo(({ row, isChecked, onToggle }) => {
  const intl = useIntl()
  return (
    <Flex gap={12} align="flex-start">
      <Checkbox
        checked={isChecked}
        disabled={row.isMapped}
        onChange={onToggle}
      />
      <Flex vertical gap={0} style={{ width: 'calc(100% - 24px)' }}>
        <Typography.Text className="bolder">
          <EllipsisTooltip className="ellipsis">
            {row.name}
          </EllipsisTooltip>
        </Typography.Text>
        <Typography.Text>
          <EllipsisTooltip className="ellipsis">
            {row.description}
          </EllipsisTooltip>
        </Typography.Text>
        {row.isMapped && (
          <Typography.Text type="danger" className="text-xs">
            {intl.formatMessage({ id: 'functionalDiagram.alreadyMapped' })}
          </Typography.Text>
        )}
      </Flex>
    </Flex>
  )
})

const CandidateConnectorsTable = ({ rows, scrollY }) => {
  const [state, dispatch] = useCandidateContext()
  const intl = useIntl()

  const columns = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: 'functionalDiagram.connectors' }),
        dataIndex: 'name',
        sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
        render: (_, row) => (
          <CandidateRow
            row={row}
            isChecked={state.selectedCandidateIds.includes(row.id)}
            onToggle={() =>
              dispatch({ type: SELECT_DESELECT_CANDIDATE, data: row.id })
            }
          />
        ),
      },
    ],
    [state.selectedCandidateIds, dispatch, intl]
  )

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={rows}
      pagination={false}
      showSorterTooltip={false}
      scroll={{ y: scrollY > 0 ? scrollY : undefined }}
      locale={{
        emptyText: (
          <div style={emptyStateStyle(scrollY)}>
            <Empty description={<RecordsCount count={0} />} />
          </div>
        ),
      }}
    />
  )
}

export default memo(CandidateConnectorsTable)
